module.exports = __webpack_public_path__ + "static/media/logo-large.6bbfdd7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/logo-large.png
// module id = 1161
// module chunks = 0